/**
 * Tracking Utility for Meta (Facebook) and TikTok Pixels
 * Usage: Import and call trackEvent('EventName', { params })
 */

const PIXEL_IDS = {
    META: '', // Add your Meta Pixel ID here
    TIKTOK: '' // Add your TikTok Pixel ID here
};

export const initTracking = () => {
    if (typeof window === 'undefined') return;

    // --- Meta Pixel (Facebook) ---
    if (PIXEL_IDS.META) {
        !function (f, b, e, v, n, t, s) {
            if (f.fbq) return; n = f.fbq = function () {
                n.callMethod ?
                    n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            };
            if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
            n.queue = []; t = b.createElement(e); t.async = !0;
            t.src = v; s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
        }(window, document, 'script',
            'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', PIXEL_IDS.META);
        fbq('track', 'PageView');
    }

    // --- TikTok Pixel ---
    if (PIXEL_IDS.TIKTOK) {
        !function (w, d, t) {
            w.TTP = w.TTP || []; w.TTP.push({ pixelCode: PIXEL_IDS.TIKTOK });
            var s = d.createElement(t); s.async = !0; s.src = "https://analytics.tiktok.com/i18n/pixel/sdk.js?sdkid=" + PIXEL_IDS.TIKTOK;
            var a = d.getElementsByTagName(t)[0]; a.parentNode.insertBefore(s, a);
        }(window, document, 'script');
    }
};

export const trackEvent = (name, params = {}) => {
    if (typeof window === 'undefined') return;

    // Meta tracking
    if (window.fbq && PIXEL_IDS.META) {
        window.fbq('track', name, params);
    }

    // TikTok tracking
    if (window.ttq && PIXEL_IDS.TIKTOK) {
        window.ttq.track(name, params);
    }

    // Log to console in development
    if (import.meta.env.MODE === 'development') {
        console.log(`[Tracking] Event: ${name}`, params);
    }
};
